export const SIGNUP_PREMIUM_CANONICAL_EVENTS = [
  'Sign up Prompt',
  'Sign up click',
  'Sign up Success',
  'Sign up error',
  'Premium Prompt',
  'Premium Subscribed',
  'Premium Subscribed Error',
] as const

type CanonicalSignupPremiumEvent = (typeof SIGNUP_PREMIUM_CANONICAL_EVENTS)[number]

const EVENT_NAME_ALIAS_TO_CANONICAL: Record<string, CanonicalSignupPremiumEvent> = {
  sign_up_prompt: 'Sign up Prompt',
  signup_prompt: 'Sign up Prompt',
  sign_up_click: 'Sign up click',
  signup_click: 'Sign up click',
  sign_up_success: 'Sign up Success',
  signup_success: 'Sign up Success',
  sign_up_error: 'Sign up error',
  signup_error: 'Sign up error',
  premium_prompt: 'Premium Prompt',
  premium_subscribed: 'Premium Subscribed',
  premium_subscribed_error: 'Premium Subscribed Error',
}

const CANONICAL_TO_ALIASES = Object.entries(EVENT_NAME_ALIAS_TO_CANONICAL).reduce(
  (acc, [alias, canonical]) => {
    if (!acc[canonical]) {
      acc[canonical] = []
    }
    acc[canonical].push(alias)
    return acc
  },
  {} as Record<CanonicalSignupPremiumEvent, string[]>,
)

export interface NormalizedEventNameResult {
  canonicalEvent: string
  aliases: string[]
  usedAliasInput: boolean
}

export function normalizeAnalyticsEventName(event: string): NormalizedEventNameResult {
  const canonicalFromAlias = EVENT_NAME_ALIAS_TO_CANONICAL[event]
  if (canonicalFromAlias) {
    return {
      canonicalEvent: canonicalFromAlias,
      aliases: CANONICAL_TO_ALIASES[canonicalFromAlias] ?? [],
      usedAliasInput: true,
    }
  }

  if ((SIGNUP_PREMIUM_CANONICAL_EVENTS as readonly string[]).includes(event)) {
    const canonicalEvent = event as CanonicalSignupPremiumEvent
    return {
      canonicalEvent,
      aliases: CANONICAL_TO_ALIASES[canonicalEvent] ?? [],
      usedAliasInput: false,
    }
  }

  return {
    canonicalEvent: event,
    aliases: [],
    usedAliasInput: false,
  }
}

export function getCanonicalSignupPremiumEvents(): readonly string[] {
  return SIGNUP_PREMIUM_CANONICAL_EVENTS
}

